import { render, staticRenderFns } from "./GlyanecFlyer.vue?vue&type=template&id=7622dd96&scoped=true&"
import script from "./GlyanecFlyer.vue?vue&type=script&lang=js&"
export * from "./GlyanecFlyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622dd96",
  null
  
)

export default component.exports